import { Dispatch } from 'redux';

import { requestHandler } from '../../api';
import { UsersResponse } from './types';

export const getUsersToTransfer = async (
  dispatch: Dispatch,
): Promise<UsersResponse | undefined> => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/portfolio`,
    dispatch,
  });
  if (response) return response.data;
};

export const postTransferPortfolio = async (dispatch: Dispatch, data: any) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/portfolio/transfer`,
    data,
    dispatch,
  });
  return response;
};

export const getPortfolio = async (dispatch: Dispatch, userId: number) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/portfolio/${userId}`,
    dispatch,
  });
  if (response) return response.data;
};
